import { getPayments } from 'Api/AccountApi';
import { getFrequencyLabel } from 'Utils/Plans';
import { setState } from 'Utils/Store';

export const paymentsInitialState = {
  isSuccess: false,
  orders: [],
  nextBillInfo: null,
  activeBillInfo: null,
  hasPayments: false,
  error: null,
};

export const getPaymentSuccess = ({ orders, activeBillInfo, nextBillInfo }) =>
  setState('payments', {
    isSuccess: true,
    orders,
    nextBillInfo,
    activeBillInfo,
    hasPayments: orders.length > 0,
  });

export const getPaymentRequest = () =>
  setState('payments', {
    isSuccess: false,
    orders: [],
    nextBillInfo: null,
    activeBillInfo: null,
    hasPayments: false,
  });

export const getPaymentError = (payload) =>
  setState('payments', {
    isSuccess: false,
    orders: [],
    nextBillInfo: null,
    activeBillInfo: null,
    error: payload,
    hasPayments: false,
  });

export const clearPaymentHistory = () => setState('payments', paymentsInitialState);

// helpers
const getOrdersAndBillInfo = ({ order = [], nextBillInformation = {} }, appId) => {
  let nextBillInfo = null;
  let activeBillInfo = null;
  const orders = order.filter(
    (od) =>
      od.orderProductInfo.some((opi) => opi.appId === appId) && ['INVOICE', 'ORDER'].includes(od.type.toUpperCase())
  );

  // invoice or an order(no free trials)
  const nextBillOrder = orders.find(
    (order) => order.nextBillInformation && order?.paymentsInfo?.[0]?.paymentCategory !== 'REFUND' //REFUND ORDER INVOICE
  );
  if (nextBillOrder) {
    const { nextBillInformation, orderProductInfo = [] } = nextBillOrder;
    const { nextBillingDateTime, nextBillingAmount } = nextBillInformation;
    const activeOrder = orderProductInfo.find((o) => o.appId === appId);

    const { displayName, chargedPrice, retailPrice, duration, period, endDate } = activeOrder;
    const planFrequency = getFrequencyLabel({ duration, period });

    //The next billing subscription may be different than the current one
    activeBillInfo = {
      planName: displayName,
      planPrice: chargedPrice || retailPrice,
      planFrequency,
    };

    nextBillInfo = {
      nextBillingDateTime: nextBillingDateTime > 0 ? nextBillingDateTime : endDate,
      nextBillingAmount,
    };
  }

  // for free trials.
  const subscriptionsInfo = nextBillInformation?.subscriptionsInfo?.find((sub) => sub.appId === appId);
  if (subscriptionsInfo) {
    const { nextBillingDateTime, nextBillingAmount, originalPrice, displayName, duration, period } = subscriptionsInfo;
    const planFrequency = getFrequencyLabel({ duration, period });
    nextBillInfo = {
      nextBillingDateTime,
      nextBillingAmount,
      planName: displayName,
      planPrice: originalPrice,
      planFrequency,
    };
  }

  return { orders, nextBillInfo, activeBillInfo };
};

export const fetchPayments = async (appId) => {
  getPaymentRequest();
  try {
    const data = await getPayments();
    const ordersAndBillInfo = getOrdersAndBillInfo(data, appId);
    getPaymentSuccess(ordersAndBillInfo);
  } catch (error) {
    getPaymentError(error.message);
  }
};
